<app-alert-save-modal *ngIf="alertSuccess"></app-alert-save-modal>
    
<div class="alert alert-danger" *ngIf="alertError">
 Something went wrong !!!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>	
  <form #hoshin="ngForm" class="budget-control-outer-div comman-padding">
  <div class="col-md-12 col-xs-12 col-sm-12 heading">
    <span class="span-create-edit-hoshin">EDIT APPROVAL HOSHIN</span>
  </div>
  <div class="col-md-12 col-xs-12 col-sm-12 div-padding">


    <div class="col-md-12 col-xs-12 col-sm-12 col-12  div-padding display-flex">
      <div class="col-md-6 col-xs-12 col-sm-12 col-12 div-padding form-row form-font-family dropdown-margin">
        <label class="col-md-4 col-xs-12 col-sm-12 col-12 control-label" id="chapterId">Chapter<label
            class="mandatory-asterisk">*</label></label>
        <ng-select [disabled]="butDisabled" placeholder="--Select--" [items]="chapterDropDownList" bindLabel="siteName"
          [(ngModel)]="budget.chapterId" bindValue="chapterId"
          class="col-md-7 col-xs-12 col-sm-12 col-12 form-control form-element input-lg custom" name="chapterId"
          required>
        </ng-select>
      </div>
      <div class="col-md-6 col-xs-12 col-sm-12 col-12 div-padding form-row form-font-family flex-fiscalyear">
        <label class="col-md-4 col-xs-12 col-sm-12 col-12 control-label" for="fiscalYear">Fiscal Year<label
            class="mandatory-asterisk">*</label></label>
        <input [readonly]="isReadOnly" type="text" id="fiscalYear" placeholder="Enter year" autocomplete="off" minlength="4" maxlength="4"
          class="col-md-7 col-xs-12 col-sm-12 col-12 inputs-padding form-control form-element input-lg"
          [(ngModel)]="budget.fiscalYear" name="fiscalYear" #fiscalYear="ngModel"
          onkeypress='return event.charCode >= 48 && event.charCode <= 57' (blur)="setEstimatedTimeBasedOnFiscalYear()" required>
        <div class="validation-error-message validation-error-message-alugn"
          *ngIf="fiscalYear.invalid && fiscalYear.touched">Please
          enter 4 digit fiscal year in numbers
        </div>
      </div>
    </div>

    <div class="col-md-12 seconddiv-padding display-flex" >
      <div class="form-group col-md-6 form-font-family text-area-flex  div-padding Chapter-goals">
        <label for="affinityGoal" class="col-md-4 textarea-label-padding goal-label">Affinity Goal
          <label class="mandatory-asterisk">*</label>
        </label>

          <ckeditor class="ck-class" [readonly]="isReadOnly" [(ngModel)]="budget.affinityGoals" id="affinityGoal" #myckeditorAffinity="ngModel" name="affinityGoals" maxlength="500"
          [config]="removeToolbar"  debounce="1000" debounce="1000" required>
        </ckeditor>
      </div>
      <div class="form-group col-md-6 form-font-family text-area-flex outerdiv align-end">
        <label for="chapterGoals" class="col-md-4 textarea-label-padding goal-label">Chapter Goals
          <label class="mandatory-asterisk">*</label></label>
       
          <ckeditor class="ck-class" [readonly]="isReadOnly" [(ngModel)]="budget.chapterGoals" id="chapterGoals" #myckeditorGoals="ngModel" name="chapterGoals" maxlength="500"
          [config]="removeToolbar"  debounce="1000" debounce="1000" required>
        </ckeditor>
      </div>
    </div>


  </div>

  <div class="col-md-12 outerdiv">
    <div *ngFor="let hoshin of hoshins; let i=index;">
      <div class="budget-control budget-heading">
        <div data-toggle="collapse" [attr.data-target]="'#budgetId'+ i" class="budget-name-width comment-heading">
          <span class="reponse-font">BPG Initiative </span>
          <div class="approved-heading" *ngIf= "this.budget.budgetStatus =='REJECTED' && hoshin.hoshinId != null ">
            <div  class="approval reponse-font" *ngIf="hoshin.isSuperAdminApproved">
              <span>(approved)</span>
            </div>
            <div class="approval reponse-font" *ngIf="!hoshin.isSuperAdminApproved">
              <span>(rejected)</span>
            </div>
          </div>
          <label class="respone-hide initiative-style">
           
            <span  *ngIf="hoshin.bpgInitiative == null || hoshin.bpgInitiative == '' || hoshin.status == null || hoshin.status == '' || hoshin.businessDrivers == null || hoshin.businessDrivers == '' || hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null ||  hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == ''">Missing fields : </span>
            <span *ngIf="hoshin.bpgInitiative == null || hoshin.bpgInitiative == ''">BPG Initiative</span>
            <span *ngIf="(hoshin.status == null || hoshin.status == '' || hoshin.businessDrivers == null || hoshin.businessDrivers == ''
            || hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null || hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == '')"
            [hidden]="hoshin.bpgInitiative != null && hoshin.bpgInitiative != ''">,</span>
            <span *ngIf="hoshin.status == null || hoshin.status == ''"> Status</span>
            <span [hidden]="hoshin.status != null && hoshin.status != ''"
            *ngIf="(hoshin.businessDrivers == null || hoshin.businessDrivers == ''
            || hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null ||  hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == '')"
            >,</span>
            <span *ngIf="hoshin.businessDrivers == null || hoshin.businessDrivers == ''"> Business Drivers</span>
            <span [hidden]="hoshin.businessDrivers != null && hoshin.businessDrivers != ''" *ngIf="(hoshin.proposedBudget == null || hoshin.proposedBudget == '' || hoshin.kpi == null || hoshin.kpi == ''|| hoshin.frequency == null || hoshin.frequency == '')">,</span>
            <!-- <span *ngIf="hoshin.proposedBudget == null || hoshin.proposedBudget == ''"> Proposed Budget</span>
            <span [hidden]="hoshin.proposedBudget != null && hoshin.proposedBudget != ''" *ngIf="(hoshin.kpi == null || hoshin.kpi == '' || hoshin.frequency == null || hoshin.frequency == '')">,</span> -->

            <span *ngIf="hoshin.kpi == null || hoshin.kpi == ''"> KPI</span>
            <span [hidden]="hoshin.kpi != null && hoshin.kpi != ''" *ngIf="(hoshin.frequency == null || hoshin.frequency == '')">,</span>

            <span *ngIf="hoshin.frequency == null || hoshin.frequency == ''"> Frequency</span>
            </label> 

          
        </div>
        <div *ngIf="hoshin.baseHoshinExists == true" class="popup-class">
          <a class="viewButton" title="View"
          id ="bsaeHoshin{{i}}" (click)="getBaseHoshin(hoshin.hoshinId,i)"><img src="assets/images/view.png"
          class="image" alt="Angular Logo"></a>
          
         </div>

        <div  class="budget-icon-width" *ngIf ="i==0">
          <i class="fa fa-plus-circle add-icon-size" aria-hidden="true" (click)="addHoshin()" ></i>
        </div>
        <div class="budget-icon-width" *ngIf="i>0 && hoshin.hoshinId == null">
          <i  class="fa fa-times-circle add-icon-size" aria-hidden="true" (click)="removeHoshin(i,hoshin)"></i>
        </div>
      </div>

      <div id="budgetId{{i}}" class="collapse collapse-div form-font-family">
        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding" >
            <label for="bpgInitiative{{i}}" class="col-md-4 label-padding control-label">BPG Initiative<label
                class="mandatory-asterisk">*</label></label>
                <!-- [readonly]=" hoshin.hoshinId != null" -->
            <input  type="text" placeholder="Enter initiative" id="bpgInitiative{{i}}" maxlength="500" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="hoshin.bpgInitiative"
              name="bpgInitiative{{i}}" required >

          </div>
          
          <div class="col-md-6 form-row label-padding align-end">
              <label for="status{{i}}" class="col-md-4 label-padding control-label">Status<label
                class="mandatory-asterisk">*</label></label>
                <ng-select  id="businessDrivers" [items]="status" placeholder="--Select--" bindLabel="type"
                bindValue="type" [(ngModel)]="hoshin.status" name="status{{i}}" required
                class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
              <label for="businessDrivers{{i}}" class="col-md-4 label-padding control-label">Business Drivers<label
                class="mandatory-asterisk">*</label></label>
                <!-- [disabled]="butDisabled && hoshin.hoshinId != null" -->
            <ng-select  id="businessDrivers" [items]="businessDrivers" placeholder="--Select--" bindLabel="type"
              bindValue="type" [(ngModel)]="hoshin.businessDrivers" name="businessDrivers{{i}}" required
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
          </div>
            <div class="col-md-6 form-row label-padding align-end" >

                <label for="superAdminApprovalComment{{i}}" class="col-md-4 comment-label-padding control-label">Approval Amount ($)</label>
                <input id="superAdminApprovedBudget" type="number" autocomplete="off"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 '
                  [(ngModel)]="hoshin.superAdminApprovedBudget" placeholder="Enter amount" name="superAdminApprovedBudget{{i}}" #proposedBudget="ngModel" (blur)="findSuperAdminApprovedBudget()"
                >
               
            </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row align label-padding">
              <label for="frequency{{i}}" class="col-md-4 label-padding control-label">Frequency
                <label class="mandatory-asterisk">*</label>
              </label>
              <!-- [disabled]="butDisabled && hoshin.hoshinId != null" -->
                <ng-select id="businessDrivers"  [items]="frequency" placeholder="--Select--" bindLabel="type"
                bindValue="type" [(ngModel)]="hoshin.frequency" name="frequency{{i}}" required
                class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
          </div>
          <div class="col-md-6 form-row label-padding align-end" *ngIf="hoshin.frequency =='One-Time'">
              <label for="estimatedTime" class="col-md-4 label-padding control-label">Estimated Timing
                <label class="mandatory-asterisk">*</label>
              </label>
              <!-- [disabled]="butDisabled && hoshin.hoshinId != null" -->
              <input  placeholder="Select month/year"
                class="col-md-7 form-control inputs-padding collapse-control input-lg date-icon" id="estimatedTime"
                name="estimatedTime{{i}}" bsDatepicker autocomplete="off" (onShown)="onOpenCalendar($event)"
                [ngModel]="hoshin.estimatedTiming" (ngModelChange)="onDateChange($event,i)"
                [bsConfig]="{ dateInputFormat: 'MMMM YYYY' }" [minDate]="minDate" [maxDate]="maxDate" required>
  
          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row align label-padding">
            <label for="additionalFunding{{i}}" class="col-md-4 label-padding control-label">Additional Funding</label>
            <input type="number" placeholder="Additional Funding" id="additionalFunding{{i}}" maxlength="500" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="hoshin.additionalFunding"
               name ="additionalFunding{{i}}"  onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'>
          </div>
          <div class="col-md-6 form-row  align label-padding align-end" >
            <label for="evaluation{{i}}" class="col-md-4 label-padding control-label">Evaluation</label>
             
            <ng-select id="businessDrivers" [items]="evaluationList" placeholder="--Select--" bindLabel="name"
            bindValue="value" [(ngModel)]="hoshin.evaluation" name="evaluation{{i}}" 
            class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>

          </div>          
        </div>

        <div class="col-md-12 display-flex">


          <div class="col-md-6 form-row align label-padding ">
            <label for="additionalFundingSource{{i}}" class="col-md-4 label-padding control-label remove-title-margin">Additional Funding Source</label>
            <input  type="text" placeholder="Additional Funding Source" id="additionalFundingSource{{i}}" maxlength="500" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="hoshin.additionalFundingSource"
               name ="additionalFundingSource{{i}}"  
              >
          </div>

          <div class="col-md-6 form-row  align label-padding align-end disable-claimed-amount-pointer" *ngIf="hoshin.claimedAmount != null">
            <label for="claimedAmount{{i}}" class="col-md-4 label-padding control-label">Claimed Amount</label>
           <input type="number" placeholder="Additional Funding" id="claimedAmount{{i}}" maxlength="500" autocomplete="off"
              class="col-md-7 collapse-control form-control input-lg inputs-padding disable-claimed-amount" [(ngModel)]="hoshin.claimedAmount"
               name ="claimedAmount{{i}}"  onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'> 
          </div>
        </div>

        <div class="col-md-12 display-flex" *ngIf= "!noUserFound">

          <div class="col-md-6 form-row align label-padding" >
              <label for="leadId1{{i}}" class="col-md-4 label-padding control-label">Lead 1</label>
              <ng-select id="businessDrivers" [items]="userList" placeholder="--Select--" bindLabel="userFirstName"
              bindValue="userId" [(ngModel)]="hoshin.leadId1" name="leadId1{{i}}" 
              class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>

          </div>
        <div class="col-md-6 form-row align label-padding  align-end" >
          <label for="leadId2{{i}}" class="col-md-4 label-padding control-label">Lead 2</label>
           
          <ng-select id="businessDrivers" [items]="userList" placeholder="--Select--" bindLabel="userFirstName"
          bindValue="userId" [(ngModel)]="hoshin.leadId2" name="leadId2{{i}}" 
          class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>

        </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding" >
              <label for="actionPlan{{i}}" class="col-md-4 textarea-label-padding control-label">Action Plan</label>
              <!-- [ngClass]="{'pointerDisable': hoshin.hoshinId != null}" -->
              <ckeditor  class="ck-class"  [(ngModel)]="hoshin.actionPlan" id="actionPlan{{i}}" #myckeditor="ngModel" name="actionPlan{{i}}" maxlength="500"
              [config]="removeToolbarAction"  [ngModelOptions]="{standalone: true}" >
            </ckeditor>
          
              </div>
          <div class="col-md-6 form-row label-padding align-end">
              <label for="kpi{{i}}" class="col-md-4 textarea-label-padding control-label">KPI
                <label class="mandatory-asterisk">*</label></label>
              <!-- [ngClass]="{'pointerDisable': hoshin.hoshinId != null}" -->
              <ckeditor class="ck-class"   [(ngModel)]="hoshin.kpi" id="kpi{{i}}" #myckeditor="ngModel" name="kpi{{i}}" maxlength="500"
              [config]="removeToolbarKpi"  [ngModelOptions]="{standalone: true}" >
            </ckeditor>
          </div>
        </div>

        <div class="col-md-12 display-flex">
          <div class="col-md-6 form-row label-padding">
              <label for="challenges{{i}}" class="col-md-4 textarea-label-padding control-label">Challenges/<span id="counter-measure">Counter-Measure</span></label>
             
            <ckeditor class="ck-class" [(ngModel)]="hoshin.challenges" id="challenges{{i}}" #myckeditorchallenge="ngModel" name="challenges{{i}}" maxlength="500"
            [config]="removeToolbarChallenge"   [ngModelOptions]="{standalone: true}">
          </ckeditor>
          </div>
          <div class="col-md-6 form-row label-padding align-end">
              <label for="midYearResults{{i}}" class="col-md-4 textarea-label-padding control-label">Mid Year Results</label>
            
              <ckeditor class="ck-class" [(ngModel)]="hoshin.midYearResults" id="midYearResults{{i}}" #myckeditorMid="ngModel" name="midYearResults{{i}}" maxlength="500"
              [config]="removeToolbarMid"  [ngModelOptions]="{standalone: true}">
            </ckeditor>
              </div>
        </div>

        <div class="col-md-12 display-flex">
            <div class="col-md-6 form-row label-padding">
                <label for="yearEndResults{{i}}" class="col-md-4 textarea-label-padding control-label">Year End Results</label>
            
                <ckeditor class="ck-class"  [(ngModel)]="hoshin.yearEndResults" id="yearEndResults{{i}}" #myckeditorYearEnd="ngModel" name="yearEndResults{{i}}" maxlength="500"
                [config]="removeToolbarYear" [ngModelOptions]="{standalone: true}" >
              </ckeditor>
            </div>
        
        </div>

      </div>
    </div>
  </div>
<div class="display-flex div-display-dispaly">
  <div class="col-md-12 seconddiv-padding display-flex margin-top-totalbudget total-budget form-font-family"  *ngIf="this.budget.budgetStatus =='APPROVED'">
    <label class="control-label" for="approvedBudgetAmount">Approved Budget= $</label>
    <input class="total-budget-input" type="text" id="approvedBudgetAmount" autocomplete="off"
      [(ngModel)]="budget.approvedBudgetAmount" name="approvedBudgetAmount" #approvedBudgetAmount="ngModel" readonly>
  </div>
  
</div>

  <div class="text-center errorMsg" *ngIf="alertFailure">
    {{errorMsg}} !
 </div>
 <label class="respone-hide initiative-style">
  <span  *ngIf="budget.chapterId == null || budget.fiscalYear == null || budget.fiscalYear == '' || 
  budget.affinityGoals == null || budget.affinityGoals == '' || budget.chapterGoals == null || budget.chapterGoals == ''">Missing fields : </span>
  <span *ngIf="budget.chapterId == null"> Chapter</span>
  <span *ngIf="(budget.fiscalYear == null || budget.fiscalYear == '' || 
  budget.affinityGoals == null || budget.affinityGoals == '' || budget.chapterGoals == null || budget.chapterGoals == '')"
  [hidden]="budget.chapterId != null && budget.chapterId != ''">,</span>
  <span *ngIf=" budget.fiscalYear == null || budget.fiscalYear == ''"> Fiscal Year</span>
  <span [hidden]=" budget.fiscalYear != null && budget.fiscalYear != ''"
  *ngIf="(budget.affinityGoals == null || budget.affinityGoals == '' || budget.chapterGoals == null || budget.chapterGoals == '')"
  >,</span>
  <span *ngIf="budget.affinityGoals == null || budget.affinityGoals == ''"> Affinity Goals</span>
  <span [hidden]="budget.affinityGoals != null && budget.affinityGoals != ''" *ngIf="(budget.chapterGoals == null || budget.chapterGoals =='')">,</span>
  <span *ngIf="budget.chapterGoals == null || budget.chapterGoals == ''"> Chapter Goals</span>
 
  </label>
  <div class="form-group form-btn" >
      <p class="text-center errorMsg" *ngIf="approveErrorMsg">*Bpg initiative total approval amount should be equal to Approved budget</p>
    <button type="button" (click)="saveClick()" [disabled]="hoshin.invalid" 
      class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" id="savebtnApprove">SAVE</button>
   
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" data-toggle="modal"
      data-target="#myModal" (click)="cancelClick()">CANCEL</button>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

   

  </div>
</form>


<div class="modal fade " id="bpgBaseModal" data-backdrop="true" tabindex="-1"  style="background-color: rgba(0, 0, 0, 0.5);">


  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content font-color modal-top">
    
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">BPG Initiative
        </h4>
        <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
      </div>
      
      <!-- Modal body -->
    <div class="modal-body"  >
      <div class="col-md-6 inlineFlex paddLzero space">
        <label   class="col-md-4 paddLzero">BPG Initiative </label>
        <span class="col-md-7 desc-color" [attr.data-hoshinBasevalue]="hoshinBase.value">{{hoshinBase.bpgInitiative}}</span>
      </div>
    

      <div class="col-md-6 inlineFlex paddLzero space">
        <label for="status"  class="col-md-4 paddLzero">Status</label>
        <span class="col-md-7 desc-color">{{hoshinBase.status}}</span>
      </div>

      <div class="col-md-6 inlineFlex paddLzero space" >
          <label for="businessDrivers"  class="col-md-4 paddLzero">Business Drivers</label>
          <span class="col-md-7 desc-color">{{hoshinBase.businessDrivers}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space">
            <label for="proposedBudget"  class="col-md-4 paddLzero">Proposed Budget</label>
            <span class="col-md-7 desc-color">{{hoshinBase.proposedBudget | currency:'USD'}}</span>
       </div>

        
       <div class="col-md-6 inlineFlex paddLzero space"  >
          <label for="actionPlan"  class="col-md-4 paddLzero">Frequency</label>
              <span class="col-md-7 desc-color">{{hoshinBase.frequency}}</span>
        </div>

       <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.frequency == 'Monthly'||hoshinBase.frequency == 'Quarterly'||hoshinBase.frequency == 'Bi-Monthly'||hoshinBase.frequency == 'Semi-Annually' ">
          <label for="estimatedTiming"  class="col-md-4 paddLzero">Estimated Timing</label>
          <span class="col-md-7 desc-color">{{hoshinBase.estimatedTiming}}</span>
      </div>

      <div class="col-md-6 inlineFlex paddLzero space"  [hidden]="hoshinBase.lead1Name == null">
        <label for="businessDrivers"  class="col-md-4 paddLzero">Lead 1</label>
        <span class="col-md-7 desc-color">{{hoshinBase.lead1Name}}</span>
      </div>

      <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.lead2Name == null" >
        <label for="businessDrivers"  class="col-md-4 paddLzero">Lead 2</label>
        <span class="col-md-7 desc-color">{{hoshinBase.lead2Name}}</span>
      </div>


        <div class="col-md-6 inlineFlex paddLzero space"  [hidden]="hoshinBase.actionPlan == ''" >
            <label for="actionPlan"  class="col-md-4 paddLzero">Action Plan</label>
            <span class="col-md-7 desc-color"   [innerHtml]="hoshinBase.actionPlan">
            </span>
          </div>
          <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.kpi == ''">
              <label for="kpi"  class="col-md-4 paddLzero">KPI</label>
              <span class="col-md-7 desc-color"   [innerHtml]="hoshinBase.kpi">
              </span>
          </div>

        
          <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.midYearResults == ''"> 
              <label for="midYearResults"  class="col-md-4 paddLzero">Mid Year results</label>
              <span class="col-md-7 desc-color"   [innerHtml]="hoshinBase.midYearResults">
              </span>
          </div>
          <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.yearEndResults == ''"> 
            <label for="yearEndResults"  class="col-md-4 paddLzero">Year End results</label>
            <span class="col-md-7 desc-color" [innerHtml]="hoshinBase.yearEndResults">
            </span>
        </div>
              
          <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.challenges == ''">
                <label for="challenges"  class="col-md-4 paddLzero"> Challenges/Counter Measure</label>
                 <span class="col-md-7 desc-color" [innerHtml]="hoshinBase.challenges">
                  </span>
           </div> 
           <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.additionalFunding == null">
            <label for ="superAdminApprovalComment"  class="col-md-4 paddLzero">Additional Funding</label>
           <span class="col-md-7 desc-color">{{hoshinBase.additionalFunding | currency:'USD'}}</span>
          </div>

          <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.evaluation == null">
            <label for ="superAdminApprovalComment"  class="col-md-4 paddLzero">Evaluation</label>
           <span class="col-md-7 desc-color">{{hoshinBase.evaluation}}</span>
          </div>

          <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.additionalFundingSource == null">
            <label for ="superAdminApprovalComment"  class="col-md-4 paddLzero additional-funding-text-align">Additional Funding Source</label>
           <span class="col-md-7 desc-color">{{hoshinBase.additionalFundingSource}}</span>
          </div>
           
           <div class="col-md-6 inlineFlex paddLzero space" >
            <label for="superAdminApprovedBudget" class="col-md-4 paddLzero">Approval Amount</label>
            <span class="col-md-7 desc-color">{{hoshinBase.superAdminApprovedBudget | currency:'USD'}}</span>
          </div>
                     
        <div class="col-md-6 inlineFlex paddLzero space" >
            <label for ="superAdminApprovalComment"  class="col-md-4 paddLzero">Approval Comment</label>
           <span class="col-md-7 desc-color">{{hoshinBase.superAdminApprovalComment}}</span>
          </div>
   </div> 
      <!-- Modal footer -->
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary btn-danger" (click)="commonMethod()" data-dismiss="modal">Yes</button> -->
        <button type="button" class="btn btn-secondary btn-danger" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>




</div>